import { render, staticRenderFns } from "./email-extension-modal.vue?vue&type=template&id=42bc0707&scoped=true&"
import script from "./email-extension-modal.vue?vue&type=script&lang=js&"
export * from "./email-extension-modal.vue?vue&type=script&lang=js&"
import style0 from "./email-extension-modal.vue?vue&type=style&index=0&id=42bc0707&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bc0707",
  null
  
)

export default component.exports